module.exports = __webpack_public_path__ + "static/media/traumatologica.86d06f29.svg";